module.exports = __webpack_public_path__ + "img/expand-alt.984fb7be.svg";